export enum ReportActivityValue {
  CREATED = 1,
  HEADER_UPDATE = 2,
  APPROVED = 3,
  CANCELED_APPROVED = 4,
  CANCELED = 5,
  CORRECTION = 6,
  FILE_UPLOADED = 7,
  FILE_UPDATED = 8,
  FILE_DELETED = 9,
  AUTOMATIC_PROCESSING_CODE_VALUE_UPDATED = 10,
  HELPING = 11,
  HELPING_FROM_PENDING = 12,
  POSITION_UPDATED = 13,
  POSITION_CREATED = 14,
  POSITION_DELETED = 15
}

export type ReportActivityFilterType = { text: string; value: ReportActivityValue; showDetails: boolean; visible: boolean };

export const allReportActivityTypes = (isEoForm: boolean, isHelpingReport: boolean): ReportActivityFilterType[] => [
  getReportActivityType('reportActivities.created', ReportActivityValue.CREATED, true),
  getReportActivityType('reportActivities.headerUpdate', ReportActivityValue.HEADER_UPDATE, true),
  getReportActivityType('reportActivities.approved', ReportActivityValue.APPROVED),
  getReportActivityType('reportActivities.canceledApproved', ReportActivityValue.CANCELED_APPROVED),
  getReportActivityType('reportActivities.canceled', ReportActivityValue.CANCELED),
  getReportActivityType('reportActivities.correction', ReportActivityValue.CORRECTION),
  getReportActivityType('reportActivities.fileUploaded', ReportActivityValue.FILE_UPLOADED, true),
  getReportActivityType('reportActivities.fileUpdated', ReportActivityValue.FILE_UPDATED, true),
  getReportActivityType('reportActivities.fileDeleted', ReportActivityValue.FILE_DELETED, true),
  getReportActivityType('reportActivities.automaticProcessingCodeValueUpdated', ReportActivityValue.AUTOMATIC_PROCESSING_CODE_VALUE_UPDATED, true),
  getReportActivityType('reportActivities.helping', ReportActivityValue.HELPING, false, isHelpingReport),
  getReportActivityType('reportActivities.helpingFromPending', ReportActivityValue.HELPING_FROM_PENDING, false, isHelpingReport),
  getReportActivityType('reportActivities.positionUpdated', ReportActivityValue.POSITION_UPDATED, true, isEoForm),
  getReportActivityType('reportActivities.positionCreated', ReportActivityValue.POSITION_CREATED, true, isEoForm),
  getReportActivityType('reportActivities.positionDeleted', ReportActivityValue.POSITION_DELETED, true, isEoForm)
] as const;

export function getReportActivityType(text: string, value: ReportActivityValue, showDetails = false, visible = true): ReportActivityFilterType {
  return { text, value, showDetails, visible };
}
